<div class="support-center-container">
  <div class="row mb-3">
    <div class="col-12">
      <h2>Support Center</h2>
    </div>
  </div>

  <nb-tabset>
    <nb-tab tabTitle="Knowledge Base" [tabIcon]="{ icon: 'book-open-outline', pack: 'eva' }">
      <app-kb-list></app-kb-list>
    </nb-tab>

    <nb-tab tabTitle="System Updates" [tabIcon]="{ icon: 'bell-outline', pack: 'eva' }">
      <app-system-updates-list></app-system-updates-list>
    </nb-tab>

    <nb-tab tabTitle="Tickets" [tabIcon]="{ icon: 'message-circle-outline', pack: 'eva' }">
      <app-ticket-list></app-ticket-list>
    </nb-tab>

    <nb-tab tabTitle="Support Calls" [tabIcon]="{ icon: 'phone-outline', pack: 'eva' }">
      <app-admin-call-center *ngIf="role === 'admin'"></app-admin-call-center>
      <app-call-initiate *ngIf="role === 'manager' || role === 'chain_manager'"></app-call-initiate>
    </nb-tab>

    <nb-tab
      tabTitle="POS Monitoring"
      [tabIcon]="{ icon: 'monitor-outline', pack: 'eva' }"
      *ngIf="role === 'admin' || role === 'chain_manager'">
      <app-pos-monitoring></app-pos-monitoring>
    </nb-tab>
  </nb-tabset>
</div>
